import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import "../css/terms.css";

export default function Terms() {
  return (
    <>
      <Helmet>
        <title>Resumify | Terms & Conditions</title>
        <meta
          name="description"
          content="Review the terms and conditions for using Resumify, including our account guidelines, intellectual property rules, and refund policy."
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="home-page">
        <Navbar />
        <main className="legal-container">
          <div className="legal-card">
            <h1>Terms & Conditions</h1>
            <p className="legal-date">Last updated: October 2026</p>

            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using Resumify.co.uk, you agree to comply with and
              be bound by these Terms and Conditions. If you do not agree to
              these terms, please discontinue use of our platform immediately.
            </p>

            <h2>2. User Accounts & Responsibilities</h2>
            <p>
              You are responsible for maintaining the confidentiality of your
              login credentials and for all activities that occur under your
              account. You agree to provide accurate, up-to-date information
              when creating CVs or communicating with our services.
            </p>

            <h2>3. Purchases, Subscriptions & Credits</h2>
            <p>
              Pro subscriptions and single-pass PDF download credits are billed
              securely via Stripe. Pricing and credit allocations are clearly
              displayed prior to purchase.
            </p>

            <h2>4. Refund Policy</h2>
            <p>
              Due to the digital nature of instant PDF downloads and AI credit
              allocations, <strong>we generally do not offer refunds</strong>{" "}
              once credits have been consumed or files exported. However, we
              want you to have a great experience. If you encounter a technical
              bug, layout glitch, or billing error, please contact our support
              team with valid proof (such as screenshots or error logs), and we
              will review your case on an individual basis to determine if a
              credit or refund can be issued.
            </p>

            <h2>5. Intellectual Property</h2>
            <p>
              All software code, user interface designs, visual templates, and
              branding assets associated with Resumify are the exclusive
              property of Resumify. Your exported CV PDFs and custom-inputted
              text remain your sole property.
            </p>

            <h2>6. Limitation of Liability</h2>
            <p>
              While Resumify is engineered to optimize CV layouts for ATS
              parsers, we do not guarantee employment outcomes, interview
              callbacks, or job offers from prospective employers.
            </p>

            <h2>7. Contact Support</h2>
            <p>
              For inquiries regarding billing disputes, technical issues, or
              refund requests, contact us at{" "}
              <a href="mailto:admin@resumify.co.uk">admin@resumify.co.uk</a>.
            </p>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
